import React, { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useWalletProvider } from "../walletprovider/useWalletProvider";
import { AppContext } from "../AppContextProvider";

import ImageUpload from "../components/imageupload/ImageUpload";
import MPCWallet from "../components/MPCWallet";

import validator from "validator";
import SelfSignWallet from "../components/SelfSignWallet";
import { MDBSwitch, MDBTabs, MDBTabsItem, MDBTabsLink, MDBTabsContent, MDBTabsPane } from "mdb-react-ui-kit";

//import { getProfileIds, clearProfileIds, storeProfileNameId, storeProfileEmailId, storeProfile2Fa, parseName, parseEmail, parseSetting2fa } from '../utils/profileSnaps'
import { AvalancheContext, useAvalancheProvider } from "../avalanche/AvalancheProvider";
import ProfileJsonStorage from "../utils/storage/profileJsonStorage";
import { WalletProviderContext } from "../walletprovider/WalletProvider";
import { createStorageJson } from "../utils/storage/storageJsonConvert";
import * as constants from "../constants";
import { ErrorTicket, WarningTicket, InformationsTicket, NotificationsTicket } from "../components/TicketsComponent";
import NewMPCWallet from "../components/NewMPCWallet";
import DwClientComponent from "../components/dwclient/DwClientComponent";
import DwMpcBackupRecoverComponent from "../components/dwclient/DwMpcBackupRecoverComponent";
import MpcClientContractComponent from "../components/dwclient/MpcClientContractComponent";
import DwEncryptionComponent from "../components/dwclient/DwEncryptionComponent";
import { DwMpcWalletBackendProviderContext } from "../mpcwalletprovider/DwMpcWalletBackendProvider";
//import { getAvatar, setAvatar } from "../utils/dwclient/dwclient";
import { AvatarProviderContext } from "../provider/AvatarProvider";
import { collectLog, createEmptyLogsAndVars, dwReportError, recordVariable } from "../utils/diagnostics/clientErrors";
import { isDev } from "../utils/isDev";
import { getUserProfileJwt, setUserProfileJwt, myRemoveUserInfoJwt } from "../utils/dwclient/dwclientutils";
import { myRemoveAllJwt } from "../utils/dwclient/dwstorageutils";
import { myRemoveGraphJwt } from "../utils/graph/graphloader2";
import { loadJwt } from "../utils/dwclient/localstorage/jwtStorage";
import { getKeySignature } from "../utils/dataEncryption";
import WalletDeviceManager from "../components/WalletDeviceManager";
import {
  getVideoCallBackground,
  setVideoCallBackground,
  VIDEO_CALL_BACKGROUND_PRESETS,
} from "../utils/videoCallBackground";

import { FILES_PAGE } from "../data/pages";
import { zipDownload } from "../utils/zipdownload/zipdownloadworkerutil";

function SettingsPage() {
  const [showWalletDeviceManager, setShowWalletDeviceManager] = useState(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const avalancheContext = useContext(AvalancheContext);
  const { selectedWallet, selectedAccount } = useWalletProvider();
  const walletContext = useContext(WalletProviderContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const { getAvatarAsBase64, setAvatar } = useContext(AvatarProviderContext);

  const profileJsonStorage = ProfileJsonStorage.create(avalancheContext, walletContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [setting2fa, setSetting2fa] = useState(false);
  const [isSubmitActive, setIsSubmitActive] = useState(false);
  const [settingprofilvisibility, setSettingprofilvisibility] = useState(false);
  const [settingemailnotification, setSettingemailnotification] = useState(false);
  const [settingshowbalance, setSettingshowbalance] = useState(true);
  const [settingdarkmode, setSettingdarkmode] = useState(true);
  const [settingloginnotifications, setSettingloginnotifications] = useState(true);
  const [settingdatasharing, setSettingdatasharing] = useState(true);
  const [videoCallBackground, setVideoCallBackgroundState] = useState(getVideoCallBackground);
  const [result, setResult] = useState();
  const [basicActive, setBasicActive] = useState("tab1");
  const [isSentTo, setIsSentTo] = useState(false);
  const [showsDeleteNotification, setShowsDeleteNotification] = useState(false);
  const [isSendingInProgress, setIsSendingInProgress] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [isWarningTicket1, setIsWarningTicket1] = useState(false);
  const [isWarningTicket2, setIsWarningTicket2] = useState(false);
  const [isWarningTicket3, setIsWarningTicket3] = useState(false);

  const [status, setStatus] = useState("");
  const [walletCopyToast, setWalletCopyToast] = useState(false);

  const copyWalletAddress = useCallback(() => {
    if (selectedAccount) {
      navigator.clipboard.writeText(selectedAccount).then(() => {
        setWalletCopyToast(true);
        setTimeout(() => setWalletCopyToast(false), 2500);
      }).catch(() => {});
    }
  }, [selectedAccount]);

  const handleLanguageChange = (newLang) => {
    i18n.changeLanguage(newLang);
  };

  const handleVideoCallBackgroundChange = (event) => {
    const color = event.target.value;
    setVideoCallBackgroundState(color);
    setVideoCallBackground(color);
  };

  const selectVideoCallBackground = (color) => {
    setVideoCallBackgroundState(color);
    setVideoCallBackground(color);
  };

  const getAccount = async () => {
    await loadData(selectedAccount);
  };

  const loadData = async (accountname) => {
    let logsAndVars = createEmptyLogsAndVars("SettingsPage:loadData");
    try {
      try {
        const avatarBase64 = await getAvatarAsBase64(selectedWallet.provider);
        if (avatarBase64 !== undefined) {
          recordVariable(logsAndVars, "avatarBase64", avatarBase64);
          setResult(avatarBase64);
          collectLog(logsAndVars, "setResult is done");
        }
      } catch (error) {
        dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
      }

      const authToken = await loadJwt();
      const userProfile = await getUserProfileJwt(selectedWallet.provider, authToken);
      recordVariable(logsAndVars, "profile data for " + accountname, userProfile);
      setName(userProfile?.name ?? "");
      setEmail(userProfile?.email ?? "");
      setSetting2fa(userProfile?.twoFactor ?? false);
      setSettingemailnotification(userProfile?.emailNotification ?? false);
      setSettingprofilvisibility(userProfile?.profileVisibility ?? false);
      setSettingdatasharing(userProfile?.dataSharing ?? false);
      setSettingdarkmode(userProfile?.darkMode ?? true);
      setSettingloginnotifications(userProfile?.loginNotifications ?? true);
      setSettingshowbalance(userProfile?.showBalance ?? false);
      localStorage.setItem("isLoginNotifications", userProfile?.loginNotifications ?? true);
      setIsSubmitActive(false);
      collectLog(logsAndVars, "settings page data set");
    } catch (error) {
      dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
      console.log(error);
    }
  };

  const saveData = async (event) => {
    if (event?.preventDefault) event.preventDefault();

    const logsAndVars = createEmptyLogsAndVars("SettingsPage:saveData");
    recordVariable(logsAndVars, "email (state)", email);
    /* if (!validator.isEmail(email)) {
      console.log("This is not email!");
      return;
    }*/
    //context.onSetLoaderTrue();
    setIsSendingInProgress(true);
    setIsSubmitActive(false);
    try {
      /*const jsonObj = createStorageJson(
        name,
        email,
        setting2fa,
        settingemailnotification,
        settingprofilvisibility,
        settingdatasharing,
        settingdarkmode,
        settingloginnotifications,
        settingshowbalance,
      );*/
      const jsonObj = {
        name,
        email,
        twoFactor: setting2fa,
        emailNotification: settingemailnotification,
        profileVisibility: settingprofilvisibility,
        dataSharing: settingdatasharing,
        darkMode: settingdarkmode,
        loginNotifications: settingloginnotifications,
        showBalance: settingshowbalance,
      };
      recordVariable(logsAndVars, "json to store as profile data", jsonObj);
      const authToken = await loadJwt();
      await setUserProfileJwt(selectedWallet.provider, authToken, jsonObj);
      //profileJsonStorage.updateDataForAddress(selectedAccount, jsonObj);
      /*setTimeout(() => {
        context.onSetLoaderFalse();
      }, 2500);*/
      collectLog(logsAndVars, "profile update is done");
      setTimeout(() => {
        //context.openModal("messagemodal", "Your data has been successfully saved!");
        setIsSentTo(true);
      }, 6000);
    } catch (ex) {
      dwReportError(selectedAccount, storageProps.portalClientId, ex, { logsAndVars });
      console.log(ex);
    }
  };

  const deleteAll = async (event) => {
    event.preventDefault();
    await profileJsonStorage.deleteForAddress(selectedAccount);
    await loadData(selectedAccount);
  };

  const onSwitch2fa = async (event) => {
    setIsSubmitActive(true);
    setSetting2fa(!setting2fa);
  };

  const onSwitchNotifications = async (event) => {
    setIsSubmitActive(true);
    setSettingemailnotification(!settingemailnotification);
  };

  const onSwitchVisibility = async (event) => {
    setIsSubmitActive(true);
    setSettingprofilvisibility(!settingprofilvisibility);
  };

  const onSwitchSharing = async (event) => {
    setIsSubmitActive(true);
    setSettingdatasharing(!settingdatasharing);
  };

  const onSwitchBalance = async (event) => {
    setIsSubmitActive(true);
    setSettingshowbalance(!settingshowbalance);
  };

  const onSwitchDarkmode = async (event) => {
    setSettingdarkmode(!settingdarkmode);
    if (settingdarkmode) {
      context.onSetLightMode();
      localStorage.setItem("isdarkmode", false);
    } else {
      context.onSetDarkMode();
      localStorage.setItem("isdarkmode", true);
    }
  };

  const onSwitchLoginnotification = async (event) => {
    console.log(event);
    setIsSubmitActive(true);
    setSettingloginnotifications(!settingloginnotifications);
    if (settingloginnotifications) {
      localStorage.setItem("isLoginNotifications", false);
    } else {
      localStorage.setItem("isLoginNotifications", true);
    }
  };

  /*const savePhoto = async (photoBase64) => {
    await profilePhotoStorage.set(photoBase64);
  };*/

  const savePhotoAsFile = async (photoFile) => {
    const logsAndVars = createEmptyLogsAndVars("SettingsPage:savePhotoAsFile");
    recordVariable(logsAndVars, "photoFile (param)", photoFile);
    if (selectedAccount !== null && photoFile !== null) {
      try {
        collectLog(logsAndVars, "starting to save avatar to backend");
        await setAvatar(selectedWallet.provider, photoFile);
        collectLog(logsAndVars, "save avatar to backend is done");
        try {
          const reader = new FileReader();
          reader.onloadend = () => { if (reader.result) setResult(reader.result); };
          reader.readAsDataURL(photoFile);
        } catch (_) {}
        context.onSetIsRender();
        setIsSendingInProgress(true);
        setTimeout(() => {
          setIsSentTo(true);
        }, 6000);
      } catch (error) {
        dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
        setErrorMessage(t('settings.avatarSaveError'));
      }
    } else {
      //setErrorMessage("Error: Webpage is not fully loaded or file has not been chosen.");
    }
  };

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  useEffect(() => {
    if (storageProps.loaded && selectedWallet) {
      getAccount();
    }
  }, [selectedWallet, storageProps.loaded]);

  useEffect(() => {
    context.closeModal();
  }, []);

  const onDeleteUser = async () => {
    if (selectedAccount !== null) {
      try {
        const authToken = await loadJwt();
        await myRemoveUserInfoJwt(authToken);
        setShowsDeleteNotification(true);
      } catch (error) {
        console.log("error: ", error);
        setStatus("error: " + error.message);
      }
    } else {
      setStatus("selectedAccount is null");
    }
  };

  const onDeleteAll = async () => {
    if (selectedAccount !== null) {
      try {
        const authToken = await loadJwt();
        await myRemoveAllJwt(authToken);
        setShowsDeleteNotification(true);
      } catch (error) {
        console.log("error: ", error);
        setStatus("error: " + error.message);
      }
    } else {
      setStatus("selectedAccount is null");
    }
  };

  const onResetGraph = async () => {
    if (selectedAccount !== null) {
      try {
        const authToken = await loadJwt();
        await myRemoveGraphJwt(authToken);
        setShowsDeleteNotification(true);
      } catch (error) {
        console.log("error: ", error);
        setStatus("error: " + error.message);
      }
    } else {
      setStatus("selectedAccount is null");
    }
  };

  const onResetAllDaten = async () => {
    if (selectedAccount !== null) {
      try {
        const authToken = await loadJwt();
        await myRemoveUserInfoJwt(authToken);
        await myRemoveAllJwt(authToken);
        await myRemoveGraphJwt(authToken);
        setShowsDeleteNotification(true);
      } catch (error) {
        console.log("error: ", error);
        setStatus("error: " + error.message);
      }
    } else {
      setStatus("selectedAccount is null");
    }
  };

  return (
    <>
      <div className="admin-tabs-settings">
        <div className="admin-title-text">
          <span className="title-text">{t('settings.title')}</span>
          <button type="button" className="button large outline" onClick={() => navigate(FILES_PAGE.url)}>
            <span className="text">{t('settings.buttons.backToApplication')}</span>
          </button>
        </div>

        <div className="settings-main">
          <form className="settings-profile-form" autoComplete="off" onSubmit={saveData}>
            <div className="form-div">
              <div className="toggleable-settings">
                <div className="title-div">
                  <span>{t('settings.accountInfo.title')}</span>
                </div>
                <ImageUpload profileData={result} savePhotoAsFile={savePhotoAsFile} />
                <div className="form-row">
                  <div className="div-2">
                    <label htmlFor="name" className="navbar-text">
                      {t('settings.accountInfo.name')}
                    </label>
                    <span>
                      {t('settings.accountInfo.nameDescription')}
                    </span>
                    <input
                      id="name"
                      name="name"
                      placeholder={t('mobile.settings.name_placeholder')}
                      className="input-text"
                      type="text"
                      onChange={(event) => {
                        setName(event.target.value);
                        setIsSubmitActive(true);
                      }}
                      value={name}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="div-2">
                    <label htmlFor="email" className="navbar-text">
                      {t('settings.accountInfo.email')}
                    </label>
                    <span>
                      {t('settings.accountInfo.emailDescription')}
                    </span>
                    <input
                      id="email"
                      name="email"
                      type="text"
                      placeholder={t('mobile.settings.email_placeholder')}
                      className="input-text"
                      onChange={(event) => {
                        setEmail(event.target.value);
                        setIsSubmitActive(true);
                      }}
                      value={email}
                      pattern={constants.EMAIL_REGEX}
                    />
                  </div>
                </div>
              </div>

              <div className="toggleable-settings">
                <div className="title-div">
                  <span>{t('settings.generalSettings.title')}</span>
                </div>
                <div className="settings-toggle-row">
                  <div>
                    <span className="settings-toggle-label">{t('settings.generalSettings.hideWalletBalance')}</span>
                    <div className="settings-toggle-sublabel">{t('settings.generalSettings.hideWalletBalanceDescription')}</div>
                  </div>
                  <button
                    type="button"
                    className={`settings-toggle ${!settingshowbalance ? "active" : ""}`}
                    onClick={onSwitchBalance}
                  >
                    <span className="settings-toggle-knob" />
                  </button>
                </div>
                {/*
                <div className="toggleable-item">
                  <div className="text-div">
                    <p style={{ textAlign: "left" }} className="settings">
                      Permanent dark mode
                    </p>
                    <span>If deactivated, design will match your browser settings.</span>
                  </div>
                  <div className="toggle">
                    <MDBSwitch id="flexSwitchCheckDefault" checked={settingdarkmode} onChange={onSwitchDarkmode} />
                  </div>
                </div>
                */}
                <div className="settings-toggle-row">
                  <div>
                    <span className="settings-toggle-label">{t('settings.generalSettings.showLoginNotifications')}</span>
                    <div className="settings-toggle-sublabel">{t('settings.generalSettings.showLoginNotificationsDescription')}</div>
                  </div>
                  <button
                    type="button"
                    className={`settings-toggle ${settingloginnotifications ? "active" : ""}`}
                    onClick={onSwitchLoginnotification}
                  >
                    <span className="settings-toggle-knob" />
                  </button>
                </div>
                <div className="settings-toggle-row">
                  <div>
                    <span className="settings-toggle-label">{t('settings.chatSecurity.title')}</span>
                    <div className="settings-toggle-sublabel">{t('settings.chatSecurity.description')}</div>
                  </div>
                  <button
                    type="button"
                    className="button outline settings-device-manager-open"
                    onClick={() => setShowWalletDeviceManager(true)}
                  >
                    {t('settings.chatSecurity.load')}
                  </button>
                </div>
              </div>
            </div>
            <div className="settings-profile-save">
              <button type="submit" className="button medium brand" disabled={!isSubmitActive}>
                <div className="text p15">{t('settings.buttons.saveChanges')}</div>
              </button>
            </div>
          </form>


          <div className="settings-extra-panels">
            <div className="settings-extra-card">
              <div className="settings-extra-card-header">{t('settings.wallet.title')}</div>
              <div className="settings-extra-card-row">
                <span className="settings-extra-card-row-label">{t('settings.wallet.address')}</span>
                <span className="settings-extra-card-row-value settings-mono">
                  {selectedAccount
                    ? `${selectedAccount.slice(0, 6)}...${selectedAccount.slice(-4)}`
                    : "—"}
                </span>
              </div>
              <div className="settings-extra-card-row">
                <span className="settings-extra-card-row-label">{t('settings.wallet.network')}</span>
                <span className="settings-extra-card-row-value">Avalanche C-Chain</span>
              </div>
              {selectedAccount && (
                <button
                  type="button"
                  className="settings-extra-copy-btn"
                  onClick={copyWalletAddress}
                >
                  {t('settings.wallet.copyAddress')}
                </button>
              )}
              {walletCopyToast && (
                <div className="settings-extra-toast">{t('settings.wallet.addressCopied')}</div>
              )}
            </div>

            <div className="settings-extra-card">
              <div className="settings-extra-card-header">{t('settings.appearance.title')}</div>
              <div className="settings-extra-toggle-row">
                <span className="settings-extra-toggle-label">{t('settings.appearance.darkMode')}</span>
                <button
                  type="button"
                  className={`settings-extra-toggle ${settingdarkmode ? "active" : ""}`}
                  onClick={onSwitchDarkmode}
                >
                  <span className="settings-extra-toggle-knob" />
                </button>
              </div>
              <div className="settings-extra-field">
                <label className="settings-extra-label" htmlFor="video-call-background">
                  {t('settings.appearance.videoCallBackground')}
                </label>
                <div
                  className="settings-extra-color-presets"
                  role="radiogroup"
                  aria-label={t('settings.appearance.videoCallBackgroundPresets')}
                >
                  {VIDEO_CALL_BACKGROUND_PRESETS.map((preset) => {
                    const isActive = videoCallBackground.toUpperCase() === preset.color;
                    return (
                      <button
                        key={preset.id}
                        type="button"
                        className={`settings-extra-color-preset ${isActive ? "active" : ""}`}
                        aria-pressed={isActive}
                        onClick={() => selectVideoCallBackground(preset.color)}
                      >
                        <span
                          className="settings-extra-color-preset-swatch"
                          style={{ backgroundColor: preset.color }}
                        />
                        <span>{t(preset.labelKey)}</span>
                      </button>
                    );
                  })}
                </div>
                <div className="settings-extra-color-control">
                  <input
                    id="video-call-background"
                    className="settings-extra-color-input"
                    type="color"
                    value={videoCallBackground}
                    onChange={handleVideoCallBackgroundChange}
                  />
                  <span className="settings-extra-color-value">
                    {t('settings.appearance.videoCallBackgroundCustom')}: {videoCallBackground}
                  </span>
                </div>
                <span className="settings-extra-field-description">
                  {t('settings.appearance.videoCallBackgroundDescription')}
                </span>
              </div>
              <div className="settings-extra-field">
                <label className="settings-extra-label">{t('settings.language.label')}</label>
                <select
                  className="settings-extra-select"
                  value={i18n.resolvedLanguage || i18n.language}
                  onChange={(e) => handleLanguageChange(e.target.value)}
                >
                  <option value="en">English</option>
                  <option value="de">Deutsch</option>
                </select>
              </div>
            </div>

            <div className="settings-extra-card">
              <div className="settings-extra-card-header">{t('settings.version.title')}</div>
              <div className="settings-extra-card-row">
                <span className="settings-extra-card-row-label">{t('settings.version.label')}</span>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <span className="settings-extra-card-row-value">v2.0.0-beta</span>
                  <span className="settings-extra-build-meta">
                    {(typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : '')}
                    {(typeof __BUILD_COMMIT__ !== 'undefined' && __BUILD_COMMIT__ !== 'unknown') ? ` (${__BUILD_COMMIT__})` : ''}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="settings-danger-zone">
            <button type="button" className="button medium brand" onClick={() => setIsWarningTicket2(true)}>
              <div className="text p15">{t('settings.buttons.removeAllFiles')}</div>
            </button>
          </div>

          {/*<SelfSignWallet/>*/}
          {/*window.innerWidth > 992 && (
                <>
                  <div className="profile-form-settings">
                    <div className="toggleable-settings">
                      <MPCWallet profileJsonStorage={profileJsonStorage} selectedAccount={selectedAccount} />
                      <NewMPCWallet />
                    </div>
                  </div>
                  <div className="profile-form-settings">
                    <div className="toggleable-settings">
                      <NillionNewComponent
                        getDefaultDataToStore={async () => {
                          const resultObj = await profileJsonStorage.getDataForAddress(selectedAccount);
                          console.log(resultObj);
                          console.log(resultObj?.portalClientId);
                          return resultObj?.portalClientId;
                        }}
                      />
                      <NillionNewestComponent />
                    </div>
                  </div>
                </>
              )*/}
        </div>
        {/*
            <div className="settings-main">
              {isDev() && (
                <>
                  <DwClientComponent />
                  <DwMpcBackupRecoverComponent />
                  <MpcClientContractComponent />
                    <DwEncryptionComponent />
                </>
              )}
            </div>
            */}
      </div>
      {showWalletDeviceManager && (
        <div
          className="settings-device-manager-overlay"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setShowWalletDeviceManager(false);
          }}
        >
          <div
            className="settings-device-manager-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="chat-security-devices-title"
          >
            <button
              type="button"
              className="settings-device-manager-close"
              aria-label="Close"
              onClick={() => setShowWalletDeviceManager(false)}
            >
              ×
            </button>
            <WalletDeviceManager />
          </div>
        </div>
      )}
      <div className="ticket-div">
        {isSendingInProgress && (
          <>
            <InformationsTicket close={() => setIsSendingInProgress(false)} text={t('settings.savingInProgress')} />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isSentTo && (
          <>
            <NotificationsTicket
              close={() => {
                setIsSentTo(false);
                context.onSetIsRender();
              }}
              text={t('settings.dataSaved')}
            />
            <div style={{ height: "20px" }} />
          </>
        )}

        {showsDeleteNotification && (
          <>
            <NotificationsTicket
              close={() => {
                setShowsDeleteNotification(false);
                context.onSetIsRender();
              }}
              text={"Deletion completed successfully!"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}

        {errorMessage && (
          <>
            <ErrorTicket close={() => setErrorMessage(undefined)} text={errorMessage} />
            <div style={{ height: "16px" }} />
          </>
        )}
        {isWarningTicket1 && (
          <>
            <WarningTicket
              close={() => {
                setIsWarningTicket1(false);
              }}
              text={"Are you sure that you want to remove Graph and Metadata?"}
              actionsButton={true}
              onDelete={() => {
                onResetGraph();
                setIsWarningTicket1(false);
              }}
              buttonText={"Delete"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isWarningTicket2 && (
          <>
            <WarningTicket
              close={() => {
                setIsWarningTicket2(false);
              }}
              text={"Are you sure that you want to delete all?"}
              actionsButton={true}
              onDelete={() => {
                onResetAllDaten();
                setIsWarningTicket2(false);
              }}
              buttonText={"Delete"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
      </div>
    </>
  );
}
export default SettingsPage;
